import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  footer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    '& *': {
      verticalAlign: 'top',
    },
  },
  link: {
    display: 'inline-block',
    textDecoration: 'none !important',
  },
}))
